
import React from 'react';
import 'swiper/css';
import 'swiper/css/free-mode';
import { currencyDisplay } from '../helpers/commonHelper';

const StockDetails = ({ onBack, stockSummary }) => {
 
    
    
  const clientData = JSON.parse(sessionStorage.getItem('clientSettings') || 'null');
   
    

    return (
        <div className="w-full h-[100dvh] flex flex-col relative">
         
          <div className="sticky top-0 z-50 bg-white px-4 pt-4 pb-2 border-b border-gray-200">
            <div
              className="absolute top-4 left-4 bg-white p-2  cursor-pointer"
              onClick={onBack}
            >
              <i className="ri-arrow-go-back-fill text-[20px] text-gray-600 hover:text-indigo-600"></i>
            </div>
      
            <div className="pl-14">
              <h1 className="text-lg sm:text-3xl font-QBold text-gray-800">{stockSummary.locationName}</h1>
              <h2 className="text-sm sm:text-xl font-QSemiBold text-gray-600"> Stock Report</h2>
            </div>
          </div>
      
         
          <div className="flex-1 overflow-y-auto px-4 pt-2 x bg-white">
            <div className="space-y-3 pb-44">
              {stockSummary.stock.map((dept, index) => (
                <div
                  key={index}
                  className="p-3 sm:p-4 bg-gradient-to-r from-gray-50 to-white rounded-lg border border-gray-200"
                >
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-4">
                    {/* Department Name */}
                    <div className="flex items-center flex-1 min-w-0">
                      <h3 className="font-QBold text-gray-800 truncate text-sm sm:text-base">
                        {dept.department}
                      </h3>
                    </div>
      
                    {/* Stock & Value */}
                    <div className="flex flex-col sm:flex-row sm:space-x-6 space-y-1 sm:space-y-0">
                      <div className="flex sm:flex-col justify-between sm:justify-start">
                        <div className="text-xs text-gray-500 font-QMedium sm:mb-1">STOCK</div>
                        <div
                          className={`font-mono text-sm sm:text-base font-QSemiBold ${
                            dept.stock < 0 ? 'text-red-600' : 'text-indigo-600'
                          }`}
                        >
                          {dept.stock.toLocaleString()}
                        </div>
                      </div>
      
                      <div className="flex sm:flex-col justify-between sm:justify-start">
                        <div className="text-xs text-gray-500 font-QMedium sm:mb-1">VALUE</div>
                        <div className="font-mono text-sm sm:text-base font-QSemiBold text-green-600">
                        {clientData?.mainCurrencyName} {currencyDisplay(dept.stockValue)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
      
};



export default StockDetails;
